/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'write': {
    width: 10.842,
    height: 10.75,
    viewBox: '0 0 10.842 10.75',
    data: '<path pid="0" d="M3.611 7.216l1.75-.145 4.008-4.008-1.606-1.605-4.007 4.011zM10.842 1.605l-.935.935L8.303.936 9.238 0z"/><path pid="1" d="M1.407 2.217h3.199V.806H0v9.944h9.941V5.469H8.53v3.87H1.407z"/>'
  }
})
